<template>
	<div class="statistics-wid">
		<div class="ftr-1-25 ftw600">
			{{ $t('statistics.total') }}
		</div>
		<div class="mt-3 bg-w p-2">
			<a-tabs v-model:activeKey="activeKey">
			   <a-tab-pane key="1" :tab="$t('statistics.thisMonth')"></a-tab-pane>
			   <a-tab-pane key="2" :tab="$t('statistics.lastMonth')"></a-tab-pane>
			   <a-tab-pane key="3" :tab="$t('statistics.pastYear')"></a-tab-pane>
				<a-tab-pane key="4" :tab="$t('statistics.allTime')"></a-tab-pane>
			 </a-tabs>
			 <div class="flex alcenter wrap around">
			 	<div class="border-gray statistics-item" v-for="(item,index) in list" :key="index">
					<img :src="item.icon" alt="" />
					<div class="cl-black ftr-1-25">
						{{item.num}}
					</div>
					<div class="cl-info">
						{{item.title}}
					</div>
				</div>
			 </div>
		</div>
		<!-- <div class="mt-3 d-flex">
			<div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66">
					<div>
						{{ $t('statistics.netIncomeTotal') }}
					</div>
					<div class="">
						{{convertCurrency(info.accumulative_money)|| 0}}{{getCurrency()}}
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-142 mt10">
					<div>
						{{ $t('statistics.unparticipatedTrials') }}
					</div>
					<div>
						{{info.reservation_order_exception_status_1 || 0}}/{{info.reservation_order_exception_count || 0}}
					</div>
				</div>
			</div>
			<div class="ml10">
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66">
					<div>
						{{ $t('statistics.tutoringHours') }}
					</div>
					<div class="">
						{{ (Number(info.total_time)/60/60).toFixed(2) || 0 }}{{$t('common.hour')}}
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66 mt10">
					<div>
						{{ $t('statistics.averageRating') }}
					</div>
					<div class="">
						{{info.teacher_comment_score_avg}}
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66 mt10">
					<div>
						{{ $t('statistics.totalRatings') }}
					</div>
					<div class="">
						{{info.teacher_comment_score_count}}
					</div>
				</div>
			</div>
			<div class="ml10">
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66">
					<div>
						{{ $t('statistics.totalStudents') }}
					</div>
					<div class="">
						{{info.user_count||0}}
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-142 mt10">
					<div>
						{{ $t('statistics.averageClassRating') }}
					</div>
					<div>
						{{(Number(info.total_time)/60/60).toFixed(2)/info.teacher_comment_score_count || 0}}
					</div>
					<div class="cl-info ft12">
						{{ $t('statistics.allCoursesStudentAvgRating') }}
					</div>
				</div>
			</div>
			<div class="ml10">
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-142">
					<div>
						{{ $t('statistics.hoursPerStudent') }}
					</div>
					<div>
						{{(Number(info.total_time)/60/60).toFixed(2)/info.user_count || 0}}{{$t('common.hour')}}
					</div>
					<div class="cl-info ft12">
						{{ $t('statistics.calculationMethod') }}
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66 mt10">
					<div>
						{{ $t('statistics.attendanceStatus') }}
					</div>
					<div class="">
						{{info.reservation_order_teacher_entry_time_null}}
					</div>
				</div>
			</div>
		</div> 
		<div class="ftr-1-25 ftw600 mt-4">
			{{ $t('statistics.annualPerformanceLast365Days') }}
		</div>-->
		 <div class="mt-3">
			<!-- <div class="d-flex">
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66">
					<div>
						{{ $t('statistics.profileViews') }}
					</div>
					<div class="">
						{{info.teacher_page_view}}
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66 ml10">
					<div>
						{{ $t('statistics.studentConversionRate') }}
					</div>
					<div class="">
						{{info.year_user_conversion_rate}}%
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66 ml10">
					<div>
						{{ $t('statistics.effectiveClassHours') }}
					</div>
					<div class="">
						{{(info.year_total_time/3600).toFixed(2) || 0}}{{$t('common.hour')}}
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66 ml10">
					<div>
						{{ $t('statistics.hourlyRate') }}
					</div>
					<div class="">
						{{convertCurrency((info.year_total_time/3600) / info.year_teacher_money_log_source3_sum ||0  )}}{{getCurrency()}}
					</div>
				</div>
			</div> -->
			<!-- <div class="d-flex mt-2">
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66">
					<div>
						{{ $t('statistics.newStudents') }}
					</div>
					<div class="">
						{{info.year_new_user_count}}
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66 ml10">
					<div>
						{{ $t('statistics.activeStudents') }}
					</div>
					<div class="">
						{{info.year_reservation_order_user_count}}
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66 ml10">
					<div>
						{{ $t('statistics.classHoursPerActiveStudent') }}
					</div>
					<div class="">
						{{ ((info.year_total_time/3600) / info.year_reservation_order_user_count).toFixed(2) || 0 }}{{$t('common.hour')}}
					</div>
				</div>
				<div class="p-2 border-gray bg-w br4 s-wid-163 s-height-66 ml10">
					<div>
						{{ $t('statistics.trialClassRating') }}
					</div>
					<div class="">
						{{info.year_teacher_comment_score_avg_experience}}
					</div>
				</div>
			</div> -->
		</div> 

		<div class="flex justify-content-between mt-4">
			<div class="flex">
				<div class="px-2 text-center py-2 br8   clickAct" style="width: 96px;"
					:class="timeIndex===0?'bg-theme cl-w':'bg-w border-gray'" @click="changeTime(0)">
					{{ $t('statistics.allTime') }}
				</div>
				<div class="px-2 text-center py-2 br8  ml10  clickAct" style="width: 96px;"
					:class="timeIndex==1?'bg-theme cl-w':'bg-w border-gray'" @click="changeTime(1)">
					{{ $t('statistics.thisMonth') }}
				</div>
				<div class="px-2 text-center py-2 br8 ml10 clickAct" style="width: 96px;"
					:class="timeIndex==2?'bg-theme cl-w':'bg-w border-gray'" @click="changeTime(2)">
					{{ $t('statistics.lastMonth') }}
				</div>
				<div class="px-2 text-center py-2 br8 ml10 clickAct" style="width: 96px;"
					:class="timeIndex==3?'bg-theme cl-w':'bg-w border-gray'" @click="changeTime(3)">
					{{ $t('statistics.pastYear') }}
				</div>
			</div>
			<div class="px-2 text-center py-2 br8 bg-w ml10 border-gray clickAct" @click="downLoad()">
				{{ $t('statistics.downloadIncomeReport') }}
			</div>
		</div>
		<div class="flex alcenter space mt-3 bg-w " style="padding: 12px 20px 0 44px;">
			<div class="ftw600 ftr-1-5 cl-black" >
				{{getCurrency()}}{{convertCurrency(sum_money)}}
			</div>
			<a-select style="width: 180px;margin-left: 10px;" :placeholder="$t('teacherSet.select')">
				<a-select-option :value="0">{{$t('statistics.filterType')}}</a-select-option>
			</a-select>
		</div>
		
		<div ref="echartsRef" class="bg-w " style="width: 100%; height: 400px;"></div>
	</div>
</template>


<script>
	import * as echarts from 'echarts';
	export default {
		data() {
			return {
				timeIndex: 0,
				option: {
					xAxis: {
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: [820, 932, 901, 934, 1290, 1330, 1320],
						type: 'line'
					}]
				},
				info: {},
				createtime_max: '',
				createtime_min: '',
				myChart: {},
				sum_money:0,
				activeKey:'1',
				list:[
					{
						title:this.$t('statistics.totalStudents'),
						num:0,
						icon: require('@/assets/image/teacher/statistics1.jpg'),
					},
					{
						title:this.$t('statistics.title2'),
						num:'HK$23600,00',
						icon:require('@/assets/image/teacher/statistics2.jpg'),
					},
					{
						title:this.$t('statistics.title3'),
						num:'HK$23600,00',
						icon:require('@/assets/image/teacher/statistics3.jpg'),
					},
					{
						title:this.$t('statistics.title4'),
						num:0,
						icon:require('@/assets/image/teacher/statistics4.jpg')
					},
					{
						title:this.$t('statistics.title5'),
						num:0,
						icon:require('@/assets/image/teacher/statistics5.png')
					},
					{
						title:this.$t('statistics.title6'),
						num:0,
						icon:require('@/assets/image/teacher/statistics6.png')
					},
					{
						title:this.$t('statistics.title7'),
						num:0,
						icon:require('@/assets/image/teacher/statistics7.jpg')
					},
					{
						title:this.$t('statistics.title8'),
						num:0,
						icon:require('@/assets/image/teacher/statistics8.jpg')
					},
					{
						title:this.$t('statistics.title9'),
						num:0,
						icon:require('@/assets/image/teacher/statistics9.jpg')
					},
					{
						title:this.$t('statistics.title11'),
						num:0,
						icon:require('@/assets/image/teacher/statistics10.jpg')
					},
					{
						title:this.$t('statistics.title12'),
						num:'100%',
						icon:require('@/assets/image/teacher/statistics11.jpg')
					},
					{
						title:this.$t('statistics.title13'),
						num:0,
						icon:require('@/assets/image/teacher/statistics12.jpg')
					},
					{
						title:this.$t('statistics.title14'),
						num:0,
						icon:require('@/assets/image/teacher/statistics13.png')
					},
					{
						title:this.$t('statistics.title15'),
						num:0,
						icon:require('@/assets/image/teacher/statistics14.png')
					},
					{
						title:this.$t('statistics.title16'),
						num:'5%',
						icon:require('@/assets/image/teacher/statistics15.jpg')
					},
					{
						title:this.$t('statistics.title17'),
						num:0,
						icon:require('@/assets/image/teacher/statistics16.jpg')
					}
				]
			}
		},
		mounted() {
			this.myChart = echarts.init(this.$refs.echartsRef);

			this.statisticsInfo()
			this.getMoneyLogList(false)
		},
		methods: {
			getCurrentMonthTimestamps() {
			    const now = new Date();
			
			    // 获取当前月的第一天
			    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
			    const firstDayTimestamp = Math.floor(firstDayOfMonth.getTime() / 1000); // 本月第一天的时间戳，转换为秒
			
			    // 获取当前月的最后一天
			    const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
			    const lastDayTimestamp = Math.floor(lastDayOfMonth.getTime() / 1000); // 本月最后一天的时间戳，转换为秒
			
			    return {
			        firstDayTimestamp,
			        lastDayTimestamp
			    };
			},
			
			getCurrentWeekTimestamps() {
			    const now = new Date();
			    const currentDay = now.getDay(); // 获取今天是星期几（0-6，0是星期天）
			
			    // 计算本周星期一的日期
			    const daysToMonday = currentDay === 0 ? 6 : currentDay - 1; // 如果是星期天，则倒退6天
			    const monday = new Date(now);
			    monday.setDate(now.getDate() - daysToMonday);
			    monday.setHours(0, 0, 0, 0); // 设置为星期一的00:00:00
			    const mondayTimestamp = Math.floor(monday.getTime() / 1000); // 本周星期一的时间戳，转换为秒
			
			    // 计算本周星期日的日期
			    const sunday = new Date(monday);
			    sunday.setDate(monday.getDate() + 6); // 星期日是星期一之后的6天
			    sunday.setHours(23, 59, 59, 999); // 设置为星期日的23:59:59
			    const sundayTimestamp = Math.floor(sunday.getTime() / 1000); // 本周星期日的时间戳，转换为秒
			
			    return {
			        mondayTimestamp,
			        sundayTimestamp
			    };
			},
			downLoad(){
				let href =
				  process.env.VUE_APP_BASE_API +
				  "api/teacher/wallet/moneyLogList?token=" +
				  encodeURIComponent(localStorage.getItem("account-token"));
				 href = href + "&page=1&limit=10000&is_download=1&createtime_max=" + encodeURIComponent(this.createtime_max);
				  href = href + "&createtime_min=" + encodeURIComponent(this.createtime_min);
				window.location.href = href;
			},
			changeTime(num) {
				this.timeIndex = num
				if (this.timeIndex == 1) {
					this.createtime_max = this.getCurrentMonthTimestamps().lastDayTimestamp
					this.createtime_min = this.getCurrentMonthTimestamps().firstDayTimestamp
					this.getMoneyLogList()
				} else if (this.timeIndex == 2) {
					this.createtime_max = this.getCurrentWeekTimestamps().sundayTimestamp
					this.createtime_min = this.getCurrentWeekTimestamps().mondayTimestamp
					this.getMoneyLogList()
				} else if (this.timeIndex == 0) {
					this.createtime_max = ''
					this.createtime_min = ''
					this.getMoneyLogList()
				}
			},
			getMoneyLogList(boo) {
				this.$http.api('teacher/wallet/moneyLogList', {
					page: 1,
					limit: 100,
					createtime_max: this.createtime_max,
					createtime_min: this.createtime_min,
				}).then(res => {
					let date = [],
						amount = []
					res.list.forEach((item, index) => {
						date.push(item.createtime.substring(0, 10))
						amount.push(item.money)
					})
					this.option.xAxis.data = date
					this.option.series[0].data = amount
					this.myChart.setOption(this.option);
					this.sum_money = res.sum_money
				})
			},
			statisticsInfo() {
				this.$http.api('teacher/statistics/statisticsInfo', {
					accumulative_money: '1',
					total_time: '1',
					user_count: '1',
					reservation_order_exception_status_1: '1',
					reservation_order_exception_count: '1',
					teacher_comment_score_avg: '1',
					teacher_comment_score_count: '1',
					reservation_order_teacher_entry_time_null: '1',
					teacher_page_view: '1',
					year_user_conversion_rate: '1',
					year_total_time: '1',
					year_teacher_money_log_source3_sum: '1',
					year_new_user_count: '1',
					year_reservation_order_user_count: '1',
					year_teacher_comment_score_avg_experience: '1'
				}).then(res => {
					this.info = res.info
				})
			}
		}
	}
</script>

<style>
	.statistics-item{
		width: 180px;
		padding: 20px;
		margin-top: 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.statistics-item img{
		width: 40px;
		height: 40px;
	}
	.statistics-wid {
		width: 900px;
	}

	.s-wid-163 {
		width: 163px;
	}

	.s-height-66 {
		height: 66px;
	}

	.s-height-142 {
		height: 142px;
	}

	@media (max-width:575.98px; ) {
		.statistics-wid {
			width: 100%;
		}
	}
</style>